import I18N from '@leverege/i18n'
import React from 'react'

import Alerts from './Alerts'
import AlertsModel from './AlertsModel'

const id = 'ps.dataViewers.AlertsSupportDataViewer'

const { tf, tfIcon } = I18N.ns( id )

export default {
  id,
  type : 'ps.AlertsSupport',
  name : tf( 'name' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : 'none',
  matches : { type : 'ItemInfoDataViewer', objectType : 'store' },
  createSettings : ( props ) => {
    return AlertsModel.create()
  },
  render : ( props ) => {
    return React.createElement( Alerts, props )
  },
  getDefaultCardContentOptions : { height : 'auto' },
}
